/* @flow */
import React from 'react';
import PropTypes from 'prop-types';

import Dropdown from '../dropdown/DropdownComponent';
import DropdownSelectItemComponent from './DropdownSelectItemComponent';

import './DropdownSelect.scss';

type DefaultProps = {
  disabled: boolean,
  onChange: Function,
  position: string,
};

type Props = {
  disabled: boolean,
  onChange: Function,
  position: string,
  selectedValue: string,
  values: [
    {
      active: boolean,
      text: string,
      value: string,
    },
  ],
};

type State = {
  isOpen: boolean,
  value: string | void,
};

class DropdownSelectComponent extends React.Component<Props, State> {
  static defaultProps: DefaultProps;

  constructor(props: Props) {
    super(props);
    this.state = {
      isOpen: false,
      value: undefined,
    };
  }

  UNSAFE_componentWillMount() {
    const value = this.props.selectedValue || this.props.values[0].value;
    this.setState({ value });
  }

  componentDidMount() {
    window.addEventListener('click', this.toggleClose);
  }

  UNSAFE_componentWillReceiveProps(nextProps: { selectedValue: string }) {
    if (nextProps.selectedValue !== this.state.value) {
      this.setState({
        value: nextProps.selectedValue,
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.toggleClose);
  }

  selection = (selectedItem: { value: string }): void => {
    this.setState({
      value: selectedItem.value,
    });

    this.props.onChange(selectedItem);
    this.toggleClose();
  };

  toggleOpen = (): void => {
    if (!this.props.disabled) {
      this.setOpenStateTo(!this.state.isOpen);
    }
  };

  toggleClose = (): void => {
    this.setOpenStateTo(false);
  };

  stopPropagation = (e: { stopPropagation: () => void }): void => {
    e.stopPropagation();
  };

  setOpenStateTo(newOpenState: boolean) {
    if (newOpenState !== this.state.isOpen) {
      this.setState({
        isOpen: newOpenState,
      });
    }
  }

  render() {
    const disabledClass = this.props.disabled ? 'dropdown-select--disabled' : '';
    return (
      <span className={`dropdown-select ${disabledClass}`} onClick={this.stopPropagation}>
        <span className="dropdown-select__title" onClick={this.toggleOpen}>
          {this.state.value}
        </span>
        <Dropdown position={this.props.position} active={this.state.isOpen} arrowHighlight={false}>
          <div className="dropdown-select__fade" />
          <ul className="dropdown-select__container u-margin-0">
            {this.props.values.map((item) => (
              <DropdownSelectItemComponent key={item.value} data={item} onClick={this.selection} />
            ))}
          </ul>
        </Dropdown>
      </span>
    );
  }
}

DropdownSelectComponent.displayName = 'DropdownSelect';

DropdownSelectComponent.propTypes = {
  onChange: PropTypes.func,
  selectedValue: PropTypes.string.isRequired,
  values: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      active: PropTypes.bool,
    }),
  ).isRequired,
  disabled: PropTypes.bool,
  position: PropTypes.oneOf([
    'top-left',
    'top-center',
    'top-right',
    'right-top',
    'right-center',
    'right-bottom',
    'bottom-right',
    'bottom-center',
    'bottom-left',
    'left-bottom',
    'left-center',
    'left-top',
  ]),
};

DropdownSelectComponent.defaultProps = {
  onChange() {},
  position: 'bottom-center',
  disabled: false,
};

export default DropdownSelectComponent;
